module.exports = __webpack_public_path__ + "media/images/front/card_arrow-9706af0d55147a63a6c3b6b6fe6878d6.svg";